import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { log } from "../../../Helper";
import { toast } from "react-toastify";
import _ from "lodash";
import { Spinner } from "../../../components/Layout";
import { deleteQuoteFromResultsPage } from "../../api";
import { Button } from '@mui/material';




const InternalQuoteResultDeleteDialog = (props) => {
  const {
    openQuote,
    handleCloseQuote,
    getTableData,
    selectedMachinesForDeleteQuoteResult,
  } = props;

  const [startSpinner, setStartSpinner] = useState(false);

  const handleCloseSpinner = (event, reason) => {
    if (reason !== "backdropClick") {
      setStartSpinner(false);
    }
  };

  const handleApply = (selectedOrders) => {
    setStartSpinner(true);

    const reqObject = {
      deleteQuoteResultMachineDTOList: selectedOrders,
    };
    deleteQuoteFromResultsPage(reqObject).then((response) => {
      log("Response recived for delete quote result");
      if (response.httpResponse === 200) {
        handleCloseQuote();
        toast.success(response.message);
        setStartSpinner(false);
      } else if (response.httpResponse === 401) {
        handleCloseQuote();
        toast.warning(response.message);
        setStartSpinner(false);
      } else {
        handleCloseQuote();
        toast.error(response.message);
        setStartSpinner(false);
      }
    });
    getTableData();
    handleCloseQuote();
  };
  return (
    <>
      <div id="quote-delete-dialog-div1" className=" w-[40%]">
        <Dialog
          id="quote-delete-dialog1"
          className=""
          open={openQuote}
          onClose={handleCloseQuote}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title1">
            {"DELETE THIS QUOTE"}
          </DialogTitle>
          <DialogContent id="quote-dialog-content2">
            Are you sure you want to delete this quote ?
          </DialogContent>
          <DialogActions
            id="quote-dialog-actions1"
            className="justify-content-center"
          >
            <Button
              id="quote-apply-btn"
              color="error"
              variant="contained"
              onClick={() => handleApply(selectedMachinesForDeleteQuoteResult)}
            >
              Delete
            </Button>
            <Button
              id="quote-cancel-btn"
              color="cancel"
              variant="contained"
              onClick={handleCloseQuote}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <div>
          <Dialog
            id="avis-dialog3"
            startSpinner={startSpinner}
            handleCloseSpinner={handleCloseSpinner}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth
          >
            <DialogTitle id="alert-dialog-title3"></DialogTitle>

            <DialogContent id="avis-dialog-content3">
              <div
                id="avis-dialog-spinner"
                className="d-flex w-100 justify-content-center align-items-center"
              >
                <Spinner
                  accessibilityLabel="Loading"
                  className="uxf-spinner-border-lg"
                  animation="border"
                />
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default InternalQuoteResultDeleteDialog;
